<template>
    <aside class="sidebar">
        <div class="logo-container">
            <img :src="logoUrl" class="logo" alt="系统logo" />
        </div>

        <nav class="menu">
            <router-link
                v-for="item in menuItems"
                :key="item.path"
                :to="item.path"
                class="menu-item"
                :class="{ active: $route.name === item.name }"
                exact
            >
                <i :class="item.icon"></i>
                <span class="menu-text">{{ item.title }}</span>
            </router-link>
        </nav>

        <div class="settings">
            <button @click="logout" class="menu-item">
                <i class="fas fa-sign-out-alt"></i>
                <span class="menu-text">退出登录</span>
            </button>
        </div>
    </aside>
</template>

<script>
import { useUserStore } from "@/store/index.js";

export default {
    props: {
        activePage: String,
    },
    data() {
        return {
            logoUrl: require("@/assets/images/Xinjian-logo.png"),
            isPatientListOpen: false,
            searchQuery: "",
            selectedPatient: null,
            patients: [
                { id: 1, name: "王立群", age: 45, gender: "男" },
                { id: 2, name: "李晓红", age: 38, gender: "女" },
                { id: 3, name: "张伟", age: 52, gender: "男" },
                // 更多测试数据...
            ],
            menuItems: [
                {
                    path: "/eeg-record",
                    name: "EEGRecord",
                    title: "我的睡眠记录",
                    icon: "fas fa-brain",
                },
                {
                    path: "/sleep-report",
                    name: "SleepReport",
                    title: "睡眠报告分析",
                    icon: "fas fa-moon",
                },
                {
                    path: "/ai",
                    name: "AI",
                    title: "失眠陪伴助手",
                    icon: "fas fa-comments",
                },
                {
                    path: "/reference",
                    name: "Reference",
                    title: "知识科普",
                    icon: "fas fa-chart-line",
                },
                {
                    path: "/account-settings",
                    name: "AccountSettings",
                    title: "账户设置",
                    icon: "fas fa-user-cog",
                },
            ],
            isPatientSelected: false,
        };
    },
    computed: {
        filteredPatients() {
            return this.patients.filter((patient) =>
                patient.name
                    .toLowerCase()
                    .includes(this.searchQuery.toLowerCase())
            );
        },
        isPatientRoute() {
            return this.$route.path.startsWith("/patient/");
        },
    },
    methods: {
        togglePatientList() {
            this.isPatientListOpen = !this.isPatientListOpen;
        },
        selectPatient(patient) {
            this.selectedPatient = patient.name;
            this.isPatientListOpen = false;
            this.$router.push(`/patient/${patient.id}`);
            this.isPatientSelected = true;
        },
        async logout() {
            try {
                const userStore = useUserStore();
                await userStore.logout();
                this.$router.replace({ name: "Login" });
            } catch (error) {
                // console.error('退出登录失败:', error)
            }
        },
    },
    watch: {
        "$route.params.id"(newId) {
            this.isPatientSelected = !!newId;
            if (newId) {
                const patient = this.patients.find((p) => p.id == newId);
                this.selectedPatient = patient?.name || null;
            }
        },
    },
};
</script>

<style scoped>
.sidebar {
    position: fixed;
    left: 0;
    top: 0;
    width: min(200px, 27.8vw);
    height: 100vh;
    background: #fcfcff;
    box-shadow: 4px 0 15px rgba(113, 53, 230, 0.03);
    display: flex;
    flex-direction: column;
    z-index: 1000;
    border-right: 1px solid #f0f0ff;
    overflow: hidden;
    font-size: min(14px, 1.9vw);
}

.logo-container {
    padding: 5%;
    border-bottom: 1px solid #eee;
}

.logo {
    width: 100%;
    max-width: min(180px, 25vw);
    display: block;
    margin: 0 auto;
}

.patient-selector {
    padding: 12px;
    border-bottom: 1px solid #f5f5ff;
}

.selector-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: min(12px, 1.7vh) min(20px, 2.8vw);
    background: rgba(113, 53, 230, 0.03);
    border-radius: min(8px, 1.1vw);
    cursor: pointer;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    font-size: min(16px, 2.2vw);
}

.selector-header:hover {
    background: rgba(113, 53, 230, 0.08);
    color: var(--secondary-color);
}

.selector-header i {
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.selector-header.active-patient {
    background: rgba(113, 53, 230, 0.1) !important;
    border: 1px solid rgba(113, 53, 230, 0.2);
    color: var(--secondary-color);
    position: relative;
}

/* .selector-header.active-patient::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: var(--secondary-color);
  animation: borderGrow 0.3s ease-out;
} */

@keyframes borderGrow {
    from {
        width: 0;
    }
    to {
        width: 100%;
    }
}

.selector-header.active-patient i {
    color: var(--secondary-color);
}

.patient-list {
    margin-top: 10px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(113, 53, 230, 0.05);
    overflow: hidden;
    border: 1px solid #f5f5ff;
    max-height: 300px;
    transition: max-height 0.3s ease-in-out;
    will-change: transform, opacity;
}

.search-box {
    position: relative;
    padding: 10px;
}

.search-input {
    width: 100%;
    padding: 8px 30px 8px 15px;
    border: 1px solid #ddd;
    border-radius: 20px;
    font-size: 14px;
}

.search-icon {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    color: #666;
}

.patient-items {
    max-height: 200px;
    overflow-y: auto;
}

.patient-item {
    padding: 10px 16px;
    cursor: pointer;
    transition: all 0.2s ease-out;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.patient-item:hover {
    background: rgba(113, 53, 230, 0.03);
}

.patient-age {
    font-size: 12px;
    color: #999;
}

.slide-enter-active {
    transition: opacity 0.2s ease-out,
        transform 0.25s cubic-bezier(0.18, 0.89, 0.32, 1.28),
        max-height 0.3s ease-in-out;
    transform-origin: top;
}

.slide-leave-active {
    transition: opacity 0.15s ease-in,
        transform 0.2s cubic-bezier(0.55, 0.06, 0.68, 0.19),
        max-height 0.25s ease-in-out;
}

.slide-enter-from {
    opacity: 0;
    transform: translateY(-8px);
    max-height: 0;
}

.slide-leave-to {
    opacity: 0;
    transform: translateY(-4px);
    max-height: 0 !important;
}

.menu {
    flex: 1;
    padding: 20px 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}

.menu-item {
    display: flex;
    align-items: center;
    justify-content: start;
    padding: min(14px, 1.9vh) 0;
    padding-left: min(10px, 1.4vw);
    margin: min(8px, 1.1vh) min(20px, 2.8vw);
    color: #666;
    border-radius: min(8px, 1.1vw);
    transition: transform 0.2s ease-out,
        background 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    text-decoration: none;
    position: relative;
    overflow: hidden;
}

.menu-item:hover {
    transform: translateX(4px);
    background: rgba(113, 53, 230, 0.03);
}

.menu-item.active {
    background: linear-gradient(
        135deg,
        var(--secondary-color) 0%,
        var(--secondary-color-lighter) 100%
    );
    box-shadow: 0 2px 6px rgba(113, 53, 230, 0.15);
    color: white;
    animation: buttonActive 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.menu-item.active::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
        45deg,
        rgba(255, 255, 255, 0.1) 25%,
        transparent 25%,
        transparent 50%,
        rgba(255, 255, 255, 0.1) 50%,
        rgba(255, 255, 255, 0.1) 75%,
        transparent 75%,
        transparent
    );
    background-size: 40px 40px;
    animation: activeShine 2s linear infinite;
    opacity: 0.3;
}

@keyframes buttonActive {
    0% {
        transform: scale(0.95);
        opacity: 0.8;
    }
    50% {
        transform: scale(1.05);
    }
    100% {
        transform: scale(1);
        opacity: 1;
    }
}

@keyframes activeShine {
    from {
        background-position: 0 0;
    }
    to {
        background-position: 40px 40px;
    }
}

.menu-item.active .menu-text {
    font-weight: 400;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.menu-item.active i {
    color: rgba(255, 255, 255, 0.9) !important;
    filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.1));
    animation: iconPulse 1.5s ease-in-out infinite;
}

.menu-item i {
    width: 24px;
    margin-right: 12px;
    font-size: 18px;
    transition: transform 0.2s ease-out,
        color 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.menu-item:hover i {
    transform: scale(1.1);
    color: var(--secondary-color);
}

.menu-text {
    font-size: 15px;
    font-family: "SourceHanSansCN-Regular", sans-serif;
}

.settings {
    border-top: 1px solid #eee;
    padding: 20px 0;
    background: #fcfcff;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .sidebar {
        width: min(60px, 8.3vw);
        box-shadow: 4px 0 12px rgba(113, 53, 230, 0.05);
    }

    .logo {
        max-width: min(50px, 6.9vw);
    }

    .menu-text {
        display: none;
    }

    .menu-item {
        justify-content: center;
        padding: min(14px, 1.9vh) 0;
        margin: min(8px, 1.1vh) min(5px, 0.7vw);
    }

    .menu-item i {
        margin-right: 0;
        font-size: min(18px, 2.5vw);
    }

    .menu-item:hover {
        transform: translateY(-2px);
    }

    .menu-item.active {
        box-shadow: 0 2px 4px rgba(113, 53, 230, 0.2) inset;
        animation: none;
    }

    .menu-item.active::after {
        display: none;
    }

    .menu {
        -webkit-overflow-scrolling: touch;
        scrollbar-width: none;
        -ms-overflow-style: none;
    }

    .menu::-webkit-scrollbar {
        display: none;
    }
}

/* 轻盈滚动条 */
.patient-items::-webkit-scrollbar {
    width: 4px;
}

.patient-items::-webkit-scrollbar-thumb {
    background: rgba(113, 53, 230, 0.15);
    border-radius: 2px;
}
</style>
